import {useState} from 'react';
import cn from 'classnames';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useDispatch, useSelector} from 'react-redux';
import {clearOffersList, findOffers} from '../../../../store/redux/offers';

import Accordion from '../../../../components/mazraeKit/accordion';
import CustomMultiCheckbox from '../../../../components/mazraeKit/customMultiCheckbox';
import CategoryCards from '../../../../module/newShop/home/inputGroups';
import {RootState} from '../../../../store/redux';
import {IFiltersData, filtersData, multiSelectData} from './utils';
import MultiRangeSlider from '../../../../components/multiRangeSlider';
// import MultiRangeSlider from '../../../../components/multiRangeSlider';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
}
export interface IFilters {
  categories: Array<IFiltersKeyValuePairs>;
  sorting: string;
  has_price: boolean;
  has_store: boolean;
}
const OffersListingBottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
}: {
  openBottomSheet: boolean;
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const dispatch = useDispatch();

  const state = useSelector((state: RootState) => state.offers);
  const [minValue, set_minValue] = useState<number>(state.start_price || 0);
  const [maxValue, set_maxValue] = useState<number>(
    state?.end_price || 999000000,
  );
  const [openAccordion, setOpenAccordion] = useState<boolean>(false);

  const [filters, setFilters] = useState<IFilters>({
    categories: state.input_guid,
    sorting: state.order_by || '',
    has_price: state.has_price,
    has_store: state.has_store,
  });

  const sortingHandler = (sortingItem: IFiltersData) => {
    setFilters(prev => {
      return {...prev, sorting: sortingItem.value};
    });
  };

  const checkBoxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => {
      return {...prev, [event.target.name]: event.target.checked};
    });
  };

  return (
    <>
      <BottomSheet
        onDismiss={() => {
          setOpenBottomSheet(false);
          setFilters({
            categories: state.input_guid,
            sorting: state.order_by || 'lastest',
            has_price: state.has_price,
            has_store: state.has_store,
          });
        }}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
        className="transition ease-in-out delay-250 "
      >
        <div className="pt-2 pb-3 ">
          <div className="flex justify-between border-b px-3">
            <p className="font-Medium">فیلتر</p>
            <i
              className="icon-nameClose-remove text-xl"
              onClick={() => setOpenBottomSheet(false)}
            />
          </div>
          <div className="px-3 mt-3 mb-4">
            <span className="text-sm">دسته بندی</span>
          </div>

          <CategoryCards filters={filters} setFilters={setFilters} />
          <div className="flex items-center px-3 border-b">
            <Accordion
              accordionTitle="مرتب سازی بر اساس"
              setOpenAccordion={setOpenAccordion}
              openAccordion={openAccordion}
            >
              <div className="flex gap-2 pb-3">
                {filtersData.map(item => {
                  return (
                    <div
                      key={item.id}
                      className={cn(
                        'border-[1px] text-sm text-farm-shop-500 rounded-full border-farm-shop-500 w-fit py-2 px-2',
                        {
                          'bg-farm-shop-100': item.value === filters.sorting,
                        },
                      )}
                      onClick={() => sortingHandler(item)}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
            </Accordion>
          </div>
          <div className="flex flex-col gap-3 px-3 my-4">
            {multiSelectData.map(item => {
              return (
                <CustomMultiCheckbox
                  title={item.title}
                  id={item.id}
                  value={item.value}
                  name={item.value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    checkBoxHandler(e)
                  }
                  defaultChecked={
                    state[item.value as keyof typeof state] ? true : false
                  }
                  checked={
                    filters[item.value as keyof typeof filters] as boolean
                  }
                />
              );
            })}
          </div>
          <div className="flex flex-col px-3 text-sm text-gray-950">
            <span> محدوده قیمت (تومان) </span>
            <div className="relative">
              <div className="d-flex justify-content-between my-2 mt-4">
                <small>از{Number(minValue).toLocaleString()} </small>
                <small>تا{Number(maxValue).toLocaleString()} </small>
              </div>
              <MultiRangeSlider
                wrapperClass="mb-3"
                min={state.start_price}
                max={state.end_price}
                minVal={minValue}
                maxVal={maxValue}
                setMaxVal={set_maxValue}
                setMinVal={set_minValue}
              />
            </div>
          </div>
          <div className="flex flex-1 gap-2 px-3">
            <button
              className="flex justify-center items-center w-3/5 rounded text-white py-2.5 bg-farm-shop-500"
              onClick={() => {
                dispatch(
                  findOffers({
                    input_guid: filters.categories,
                    order_by: filters.sorting,
                    has_store: filters.has_store,
                    has_price: filters.has_price,
                    start_price: minValue,
                    end_price: maxValue,
                  }),
                );
                setOpenBottomSheet(false);
              }}
            >
              اعمال فیلترها
            </button>
            <button
              className="flex justify-center items-center w-2/5 rounded py-2.5 border-[1px] text-red-500 !border-red-500"
              onClick={() => {
                dispatch(clearOffersList());
                setOpenBottomSheet(false);
              }}
            >
              حذف فیلترها
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default OffersListingBottomSheet;
